/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Alipay_Public_KeyInputs */

const en_admin_settings_fields_alipay_public_key = /** @type {(inputs: Admin_Settings_Fields_Alipay_Public_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alipay Public Key`)
};

const zh_admin_settings_fields_alipay_public_key = /** @type {(inputs: Admin_Settings_Fields_Alipay_Public_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付宝公钥`)
};

/**
* | output |
* | --- |
* | "Alipay Public Key" |
*
* @param {Admin_Settings_Fields_Alipay_Public_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_alipay_public_key = /** @type {((inputs?: Admin_Settings_Fields_Alipay_Public_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Alipay_Public_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_alipay_public_key(inputs)
	return zh_admin_settings_fields_alipay_public_key(inputs)
});
export { admin_settings_fields_alipay_public_key as "admin.settings.fields.alipay_public_key" }